exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__selectContainer___tcJxB{width:230px}.style__fileContainer___2vRl3{width:100%;min-height:200px}.style__uploadMsg___2fx2Y{width:7rem;text-align:center;margin:0 auto;margin-top:2rem}.style__uploadIcon___2iJ6_{text-align:center;margin-top:1rem}.style__submitButton___15mSi{margin-top:1rem}", "", {"version":3,"sources":["/./containers/spreadsheetUpload/style.css"],"names":[],"mappings":"AAAA,gCACE,WAAa,CACd,AAED,8BACE,WAAY,AACZ,gBAAkB,CACnB,AAED,0BACC,WAAY,AACZ,kBAAmB,AACnB,cAAe,AACf,eAAiB,CACjB,AAED,2BACC,kBAAmB,AACnB,eAAiB,CACjB,AAED,6BACC,eAAiB,CACjB","file":"style.css","sourcesContent":[".selectContainer {\n  width: 230px;\n}\n\n.fileContainer {\n  width: 100%;\n  min-height: 200px;\n}\n\n.uploadMsg {\n\twidth: 7rem;\n\ttext-align: center;\n\tmargin: 0 auto;\n\tmargin-top: 2rem;\n}\n\n.uploadIcon {\n\ttext-align: center;\n\tmargin-top: 1rem;\n}\n\n.submitButton {\n\tmargin-top: 1rem;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"selectContainer": "style__selectContainer___tcJxB",
	"fileContainer": "style__fileContainer___2vRl3",
	"uploadMsg": "style__uploadMsg___2fx2Y",
	"uploadIcon": "style__uploadIcon___2iJ6_",
	"submitButton": "style__submitButton___15mSi"
};


//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/css-loader?modules&sourceMap&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!/data/www/SGDBackend-Nex2/~/postcss-loader!./containers/spreadsheetUpload/style.css
// module id = 568
// module chunks = 0